import React, { forwardRef } from "react";
import { NavLink, NavLinkProps } from "react-router-dom";

import ListItem from "@material-ui/core/ListItem";

export interface AppMenuItemComponentProps {
  className?: string;
  // ..because the InferProps props allows null value:
  link?: string | null;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
}

const SideNavItemComponent: React.FC<AppMenuItemComponentProps> = props => {
  const { className, onClick, link, children } = props;

  return link ? (
    <ListItem
      button
      className={className}
      children={children}
      component={forwardRef((props: NavLinkProps, ref: any) => (
        <NavLink exact {...props} innerRef={ref} />
      ))}
      to={link}
    />
  ) : (
    <ListItem
      button
      className={className}
      children={children}
      onClick={onClick}
    />
  );
};

export default SideNavItemComponent;
